module.exports = function(post) {
	"use strict";
  post
  .directive('sortableGalleryHorDir',sortableGalleryHorDir);
	sortableGalleryHorDir.$inject = [];
  function sortableGalleryHorDir() {
    return {
      require: '?ngModel',
      link: function(scope, element, attrs, ngModel) {
        var state = 'attachments';
        var options = {
          helper:'original',
          axis:'x',
          start: function(e, ui) {
            ui.item.directive = {
              start: ui.item.index(),
              startModel: ngModel
            };
          },
          update: function(e, ui) {
            var start = ui.item.directive.start;
            var end = ui.item.index();
            
            if (ui.item.closest('.ui-sortable')[0] === element[0]) {
              scope.$apply(function() {
                var element = ui.item.directive.startModel.$modelValue.splice(start, 1)[0];
                ngModel.$modelValue.splice(end, 0, element);
              });
            }
          }
        };
        element.sortable(options);
      }
    };
  }	
}


//////////////////
// WEBPACK FOOTER
// ./public/development/assets/ext-modules/postsModule/sortableImageGalleryHorDirective.js
// module id = 567
// module chunks = 0